export const obtenerEstadoRequestDesdeSaga = (sagas, nombreSaga) => {
  if (sagas !== undefined && typeof sagas === 'object' && typeof nombreSaga === 'string') {
    const saga = sagas[nombreSaga];
    if (saga !== undefined && typeof saga === 'object') {
      return saga;
    }
  }
  return { running: null, success: null, datos: [] };
};

export const handleSagaStatus = ({
  estadoPeticion,
  previousEstadoPeticion,
  onWasRunningAndHasSucceded,
  onWasRunningAndHasFailed,
  onWasStoppedAndIsRunning,
  onWasFailedAndIsRunning,
}) => {
  const { running: isRunning, success: isSuccess } = estadoPeticion;
  const { running: wasRunning, success: wasSuccess } = previousEstadoPeticion;
  if (wasRunning === true && isSuccess === true) {
    if (onWasRunningAndHasSucceded !== undefined && typeof onWasRunningAndHasSucceded === 'function') {
      onWasRunningAndHasSucceded();
    }
  }
  if (wasRunning === true && isSuccess === false) {
    if (onWasRunningAndHasFailed !== undefined && typeof onWasRunningAndHasFailed === 'function') {
      onWasRunningAndHasFailed();
    }
  }
  if (wasRunning !== true && isRunning === true) {
    if (onWasStoppedAndIsRunning !== undefined && typeof onWasStoppedAndIsRunning === 'function') {
      onWasStoppedAndIsRunning();
    }
  }
  if (wasSuccess !== true && isRunning === true) {
    if (onWasFailedAndIsRunning !== undefined && typeof onWasFailedAndIsRunning === 'function') {
      onWasFailedAndIsRunning();
    }
  }
};
